<script setup lang="ts">
    defineProps<{
        points: number | string;
    }>();
</script>

<template>
    <div class="teaser-points">
        {{ points }}
    </div>
</template>

<style scoped lang="scss">
    .teaser-points {
        position: absolute;
        right: var(--spacing--05);
        bottom: 0;
        transform: translateY(calc(50% - var(--font-sm) / 2));
        width: 56px;
        height: 56px;
        border-radius: $border-radius-circle;
        display: grid;
        place-items: center;
        background: $brand-primary;
        color: $white;
        font-size: $font-sm;
        line-height: 1;
        z-index: 2;
        font-family: 'Figtree', sans-serif;
    }
</style>
